import { render, staticRenderFns } from "./relate-dialog.vue?vue&type=template&id=5cdd3fa8&scoped=true"
import script from "./relate-dialog.vue?vue&type=script&lang=js"
export * from "./relate-dialog.vue?vue&type=script&lang=js"
import style0 from "./relate-dialog.vue?vue&type=style&index=0&id=5cdd3fa8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cdd3fa8",
  null
  
)

export default component.exports